<template>
<div>
    <div class="login_wrap">
        <dl>
            <dt>휴대폰 인증</dt>
            <dd>
                비밀번호를 잊어버리셨나요?<br>
                휴대폰 번호 인증을 통해 비밀번호를 재설정합니다.
            </dd>
        </dl>
    </div>
    <div class="btn_box_fixed">
        <a class="default_btn1" @click="niceAuth();">본인인증</a>
    </div>
</div>
    

    
</template>

<script>
import {mapState} from 'vuex';
import {NiceMixin} from '../../../mixins/NiceMixin';
export default {
    name:'PwNiceAuth',
    mixins:[NiceMixin],
    created() {
        this.$store.commit('SHOW_ONLOAD');
    },
    computed: {
        ...mapState({
            authWrite: state => state.auth.itemWrite,
        }),
    },
    methods: {
        //본인 인증
        niceAuth() {
            this.callbackPopup('Nice', this.niceResult)
        },

        //본인 인증 성공
        niceResult() {
            let niceData = this.niceGetResult();
            //성공시에만 niceData 존재
            if(niceData) {
                this.$store.dispatch('CHANGE_USER_PW_CHECK', niceData.phone)
                .then(()=>{
                    this.authWrite.name = niceData.name;
                    this.authWrite.phone = niceData.phone;
                    this.authWrite.gender = niceData.gender;
                    this.$router.push('/pw/change');
                })
                .catch((e)=>{
                    this.apiCatch(e);
                })
            }
        },


    },
    
}
</script>

<style lang="scss" scoped>

</style>